module.exports = __webpack_public_path__ + "img/index-banner1.b9d02a03.png";